/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ExecutionStatus } from './ExecutionStatus';
import {
    ExecutionStatusFromJSON,
    ExecutionStatusFromJSONTyped,
    ExecutionStatusToJSON,
    ExecutionStatusToJSONTyped,
} from './ExecutionStatus';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetReportExecutionResponse
 */
export interface GetReportExecutionResponse {
    /**
     * 
     * @type {string}
     * @memberof GetReportExecutionResponse
     */
    reportId: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportExecutionResponse
     */
    reportName: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportExecutionResponse
     */
    reportDisplayName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetReportExecutionResponse
     */
    requestedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetReportExecutionResponse
     */
    startedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetReportExecutionResponse
     */
    finishedAt: Date | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetReportExecutionResponse
     */
    requestedBy: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ExecutionStatus}
     * @memberof GetReportExecutionResponse
     */
    status: ExecutionStatus;
    /**
     * 
     * @type {string}
     * @memberof GetReportExecutionResponse
     */
    parametersJson: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportExecutionResponse
     */
    fileUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReportExecutionResponse
     */
    fileKey: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReportExecutionResponse
     */
    errorMessage: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetReportExecutionResponse
     */
    durationMs: ActorActivityRecordActorUserId | null;
}



/**
 * Check if a given object implements the GetReportExecutionResponse interface.
 */
export function instanceOfGetReportExecutionResponse(value: object): value is GetReportExecutionResponse {
    if (!('reportId' in value) || value['reportId'] === undefined) return false;
    if (!('reportName' in value) || value['reportName'] === undefined) return false;
    if (!('reportDisplayName' in value) || value['reportDisplayName'] === undefined) return false;
    if (!('requestedAt' in value) || value['requestedAt'] === undefined) return false;
    if (!('startedAt' in value) || value['startedAt'] === undefined) return false;
    if (!('finishedAt' in value) || value['finishedAt'] === undefined) return false;
    if (!('requestedBy' in value) || value['requestedBy'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('parametersJson' in value) || value['parametersJson'] === undefined) return false;
    if (!('fileUrl' in value) || value['fileUrl'] === undefined) return false;
    if (!('fileKey' in value) || value['fileKey'] === undefined) return false;
    if (!('errorMessage' in value) || value['errorMessage'] === undefined) return false;
    if (!('durationMs' in value) || value['durationMs'] === undefined) return false;
    return true;
}

export function GetReportExecutionResponseFromJSON(json: any): GetReportExecutionResponse {
    return GetReportExecutionResponseFromJSONTyped(json, false);
}

export function GetReportExecutionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportExecutionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'reportId': json['reportId'],
        'reportName': json['reportName'],
        'reportDisplayName': json['reportDisplayName'],
        'requestedAt': (new Date(json['requestedAt'])),
        'startedAt': (json['startedAt'] == null ? null : new Date(json['startedAt'])),
        'finishedAt': (json['finishedAt'] == null ? null : new Date(json['finishedAt'])),
        'requestedBy': ApiUserTasksGetPageParameterFromJSON(json['requestedBy']),
        'status': ExecutionStatusFromJSON(json['status']),
        'parametersJson': json['parametersJson'],
        'fileUrl': json['fileUrl'],
        'fileKey': json['fileKey'],
        'errorMessage': json['errorMessage'],
        'durationMs': ActorActivityRecordActorUserIdFromJSON(json['durationMs']),
    };
}

export function GetReportExecutionResponseToJSON(json: any): GetReportExecutionResponse {
    return GetReportExecutionResponseToJSONTyped(json, false);
}

export function GetReportExecutionResponseToJSONTyped(value?: GetReportExecutionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reportId': value['reportId'],
        'reportName': value['reportName'],
        'reportDisplayName': value['reportDisplayName'],
        'requestedAt': value['requestedAt'].toISOString(),
        'startedAt': value['startedAt'] == null ? value['startedAt'] : value['startedAt'].toISOString(),
        'finishedAt': value['finishedAt'] == null ? value['finishedAt'] : value['finishedAt'].toISOString(),
        'requestedBy': ApiUserTasksGetPageParameterToJSON(value['requestedBy']),
        'status': ExecutionStatusToJSON(value['status']),
        'parametersJson': value['parametersJson'],
        'fileUrl': value['fileUrl'],
        'fileKey': value['fileKey'],
        'errorMessage': value['errorMessage'],
        'durationMs': ActorActivityRecordActorUserIdToJSON(value['durationMs']),
    };
}

